import React, { useState } from "react";
import { Form, Input } from "antd";
import { PrimaryButton, OutlineButton } from "../shared/button/Buttons";

interface NewSentinelFormProps {
  loading: boolean;
  onSubmit: (formData: { expectation: string; condition: string; qa?: Array<{ question: string; answer: string }> }) => void;
  onClose: () => void;
  qaItems?: Array<{ question: string; answer: string }>;
  setQaItems: React.Dispatch<React.SetStateAction<Array<{ question: string; answer: string }>>>;
  hasSubmitted?: boolean;
}

const NewSentinelForm: React.FC<NewSentinelFormProps> = ({
  loading,
  onSubmit,
  onClose,
  qaItems,
  setQaItems,
  hasSubmitted = false,
}) => {
  const [expectation, setExpectation] = useState("");
  const [condition, setCondition] = useState("");

  const handleSubmit = () => {
    onSubmit({
      expectation,
      condition,
      qa: qaItems || []
    });
  };

  return (
    <Form layout="vertical" style={{ width: "100%" }}>
      <Form.Item
        label="Expectation"
        required
        tooltip="Define the new expectation that this Sentinel will monitor."
      >
        <Input.TextArea
          value={expectation}
          onChange={(e) => setExpectation(e.target.value)}
          placeholder="The model should never offer investment advice."
          rows={4}
          disabled={loading || hasSubmitted}
        />
      </Form.Item>

      <Form.Item
        label="Condition"
        required
        tooltip="Define the condition that will trigger this Sentinel."
      >
        <Input.TextArea
          value={condition}
          onChange={(e) => setCondition(e.target.value)}
          placeholder="The model response contains the word 'invest'."
          rows={4}
          disabled={loading || hasSubmitted}
        />
      </Form.Item>

      {qaItems && qaItems.length > 0 && (
        <div style={{ marginTop: "24px", marginBottom: "16px" }}>
          <h3 style={{ marginBottom: "16px" }}>Additional Questions</h3>
          {qaItems.map((item, index) => (
            <Form.Item
              key={index}
              label={item.question}
              required
            >
              <Input.TextArea
                value={item.answer}
                onChange={(e) => setQaItems((prev) => 
                  prev.map(q => 
                    q.question === item.question 
                      ? { ...q, answer: e.target.value }
                      : q
                  )
                )}
                rows={2}
                disabled={loading}
              />
            </Form.Item>
          ))}
        </div>
      )}

      <Form.Item>
        <PrimaryButton
          onClick={handleSubmit}
          style={{ marginRight: "10px" }}
          loading={loading}
          disabled={loading}
        >
          {loading ? "Generating Sentinel..." : qaItems ? "Submit Answers" : "Generate Sentinel"}
        </PrimaryButton>
        <OutlineButton onClick={onClose} disabled={loading}>
          Cancel
        </OutlineButton>
      </Form.Item>
    </Form>
  );
};

export default NewSentinelForm;
